import { createActionCreator } from 'utils';

const { createAction } = createActionCreator('Auth');

export const signup = createAction('Signup', (email, name, password) => ({
  email,
  name,
  password,
}));
export const signin = createAction('Signin', (email, password, callbacks) => ({
  email,
  password,
  callbacks,
}));
export const signinNavigateToInitialRoute = createAction(
  'Signin navigate to initial route',
  (callbacks) => ({ callbacks })
);
export const verifyEmail = createAction('Verify email', (data, callbacks) => ({ data, callbacks }));
export const sendVerificationEmail = createAction('Send verification email', (callbacks) => ({
  callbacks,
}));
export const publishProfile = createAction('Publish profile', (callbacks) => ({
  callbacks,
}));
export const signout = createAction('Signout');
export const setToken = createAction('Set token');
export const setUserEmail = createAction('Set user email');
export const setCurrentUser = createAction('Set current user');
export const setCurrentUserCustomFields = createAction('Set current user custom fields');
export const setUserEmailVerified = createAction('Set user email verified');
export const setApiKey = createAction('Set API key');
export const selectPublisherId = createAction('Select publisher ID');
export const setDeviceId = createAction('Set device ID');
